<div #input
     [style.font-family]="fontFamily"
     [style.font-size.px]="60 * font?.baseSizeMultiplier * viewportScale"
     [textContent]="signatureText"
     (blur)="signatureText = $any($event).target.textContent; drawSignature()"
     class="signature-input"
     contenteditable="true"
     autocapitalize="off"
     autocomplete="off"
     autocorrect="off">
</div>
<canvas #canvas></canvas>
